import { ContainerComponent, wrap } from 'AppReact';
import { SecondaryTextSmBold, Icon } from 'atoms';
import { Td, Mr2, Tr, FlexCenterJustifyCenterWrapper } from 'wrappers';
import { WrenchSvg, StarSvg } from 'components/icons';

export const definition = {
  name: 'HeaderRowContainer',
  controller: {},
  initialProps: ({ }) => ({}),
  props: {},
  elements: [
    {
      wrapper: Tr,
      name: 'Row',
      displayState: ({ }) => ({
        height: '48px',
        background: '#E7EBEB',
      }),
      elements: [
        {
          component: Td,
          name: 'Header',
          displayState: ({ }) => ({
            borderRight: '1px solid #E3E3E3',
            borderTop: '1px solid #E3E3E3',
            borderLeft: '1px solid #E3E3E3',
            borderRadius: '8px 0px 0px 0px',
          }),
          displayValue: ({ }) => '',
        },
        {
          wrapper: Td,
          colSpan: 2,
          name: 'NoAction',
          displayState: ({ }) => ({
            borderRight: '1px solid #E3E3E3',
            borderTop: '1px solid #E3E3E3',
          }),
          elements: [
            {
              wrapper: FlexCenterJustifyCenterWrapper,
              name: 'Wrapper',
              elements: [
                {
                  component: wrap(Icon, Mr2),
                  name: 'Icon',
                  displayValue: ({ }) => StarSvg({ width: 12, height: 12, filled: true, color: '#1DBD6B' })
                },
                {
                  component: SecondaryTextSmBold,
                  name: 'Property',
                  displayValue: ({ }) => 'No Action Required',
                },
              ]
            }
          ]
        },
        {
          wrapper: Td,
          name: 'Action',
          colSpan: 2,
          displayState: ({ }) => ({
            borderRight: '1px solid #E3E3E3',
            borderTop: '1px solid #E3E3E3',
          }),
          elements: [
            {
              wrapper: FlexCenterJustifyCenterWrapper,
              name: 'Wrapper',
              elements: [
                {
                  component: wrap(Icon, Mr2),
                  name: 'Icon',
                  displayValue: ({ }) => WrenchSvg({ width: 12, height: 12, color: '#FFC700' })
                },
                {
                  component: SecondaryTextSmBold,
                  name: 'Property',
                  displayValue: ({ }) => 'Action Required',
                },
              ]
            }
          ]
        },
        {
          wrapper: Td,
          name: 'RemainingColumns',
          colSpan: 3,
          displayState: ({ }) => ({
            borderRadius: '0px 8px 0px 0px',
            borderTop: '1px solid #E3E3E3',
            borderRight: '1px solid #E3E3E3',
          }),
          elements: [

          ]
        },
      ]
    }
  ]
}

export default ContainerComponent(definition);
